import ChoiceChips from "../../selection/choiceSelection";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { ChoiceBaseProps } from "models/propTypes/wintFormPropsTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";

function ChoiceBinary(props: ChoiceBaseProps) {
  const { value, setValue, setTouched } = props;

  const handleChange = (selectedItem: SelectionItem) => {
    setValue(Boolean(selectedItem.id));
    setTouched(true, false);
  };

  const items: SelectionItem<{}>[] = [
    {
      id: 0,
      value: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.No),
    },
    {
      id: 1,
      value: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Yes),
    },
  ];

  const selectedItem = value !== undefined ? items.find((x) => x.id === (value ? 1 : 0)) : undefined;

  return (
    <ChoiceChips
      title={props.label}
      items={items}
      value={selectedItem}
      onChange={handleChange}
      disabled={props.disabled}
      isReadOnly={props.readonly}
      disabledItems={props.disabledItems}
      data-testid={`${props.name}ChoiceBinary`}
    />
  );
}

export default ChoiceBinary;
